'use strict';

var _ = require('lodash');
var ChartDashboardRankingsPerformingController = function ChartDashboardRankingsPerformingController($scope, $filter, formatterService, brushRangesService, chartDashboardTooltipFormattersService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.brushRanges = [];
  function isPercentageMode() {
    return $scope.screenState.dataRepresentation === 'percentage';
  }
  function getExpectedReference(d) {
    switch ($scope.screenState.aggregationMode) {
      case 'LY':
        return d.finalRef;
      case 'BUDGET':
        return d.budget;
      case 'TARGET':
        return d.target;
    }
  }
  function diffValue(v1, v2) {
    return v1 - v2;
  }
  function percentageValue(v1, v2) {
    return v2 !== 0 ? (v1 / v2 - 1) * 100 : 0;
  }
  $scope.chartFormatters = {
    xAxisTickFormatter: formatterService.identity,
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d, isPercentageMode() ? 'PERCENTAGE_SHORT' : 'NUMBER_SHORT');
    },
    tooltipFormatter: function tooltipFormatter(data) {
      var expectedReference = getExpectedReference(data);
      var tooltipModel = _.pick(data, ['current', 'expected', 'currentRef', 'finalRef', 'target', 'budget']);
      tooltipModel.tooltipTitle = data.label;
      tooltipModel.mainCss = 'chart-rankings-performance-tooltip';
      tooltipModel.currentChangePercent = $scope.screenState.selectedMetric.id === 'loadFactor' ? diffValue(data.current, data.currentRef) : percentageValue(data.current, data.currentRef);
      tooltipModel.expectedChangePercent = $scope.screenState.selectedMetric.id === 'loadFactor' ? diffValue(data.expected, expectedReference) : percentageValue(data.expected, expectedReference);
      return chartDashboardTooltipFormattersService.getTooltip({
        data: tooltipModel,
        aggregationMode: $scope.screenState.aggregationMode,
        presentationMode: $scope.screenState.dataRepresentation,
        metric: $scope.screenState.selectedMetric.id
      });
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'dashboard-rankings-performing-chart-tooltip-' + $scope.type;
  $scope.updateBrushSelections = function (brushRanges) {
    var rankingName = $scope.ranking.name.toLowerCase();
    $scope.brushSelections[rankingName][$scope.type] = brushRangesService.getDataRange($scope.data, brushRanges);
  };
  function extractIndexes(data, labels) {
    var labelsMap = _.keyBy(labels);
    return _.reduce(data, function (result, item, index) {
      if (labelsMap[item.label]) {
        result.push(index);
      }
      return result;
    }, []);
  }
  $scope.calculateBrushRanges = function () {
    var selectedItems = $scope.brushSelections[$scope.rankingType][$scope.type];
    var indexesOfSelectedItems = extractIndexes($scope.data, selectedItems);
    var rangesOfSelected = brushRangesService.combineToRanges(indexesOfSelectedItems);
    return _.isEmpty(rangesOfSelected) ? [0, 0] : rangesOfSelected;
  };
};
ChartDashboardRankingsPerformingController.$inject = ['$scope', '$filter', 'FormatterService', 'BrushRangesService', 'ChartDashboardTooltipFormattersService'];
module.exports = ChartDashboardRankingsPerformingController;